import blue from "views/resources/icons/central/bluequeen.svg";
import booker from "views/resources/icons/central/booker.svg";
import command from "views/resources/icons/central/command.svg";
import controlPanel from "views/resources/icons/central/controlPanel.svg";
import pointer from "views/resources/icons/central/pointer.svg";
import simulator from "views/resources/icons/central/simulator.svg";
import stats from "views/resources/icons/central/stats.svg";
import university from "views/resources/icons/central/university.svg";
import web from "views/resources/icons/central/web.svg";
import webModule from "views/resources/icons/central/module.svg";

export const sites = [
	{
		icon: command,
		id: 1,
		name: "Centro de mando",
		url: "https://zeroq.cl/command",
	},
	{
		icon: controlPanel,
		id: 2,
		name: "Panel de control",
		url: "https://zeroq.cl/control",
	},
	{
		icon: stats,
		id: 3,
		name: "Panel de estadístico",
		url: "https://zeroq.cl/stats",
	},
	{
		icon: booker,
		id: 4,
		name: "Reservador",
		url: "https://zeroq.cl/reservador",
	},
	{
		icon: webModule,
		id: 5,
		name: "Módulo web",
		url: "https://zeroq.cl/modulo",
	},
	{
		icon: blue,
		id: 8,
		name: "Bluequeen",
		url: "https://comercial.zeroq.cl/bluequeen-2",
	},
	{
		icon: simulator,
		id: 9,
		name: "Simulador",
		url: "https://zeroq.cl/simulador",
	},
	{
		icon: university,
		id: 10,
		name: "ZeroQ University",
		url: "https://university.zeroq.cl/ ",
	},
	{
		icon: web,
		id: 11,
		name: "Web ZeroQ",
		url: "https://zeroq.cl/",
	},
	{
		icon: pointer,
		id: 12,
		name: "Descubre ZeroQ",
		url: "https://comercial.zeroq.cl/",
	},
];
